import { render, staticRenderFns } from "./SettingsLayoutTopBar.vue?vue&type=template&id=b21aa706"
import script from "./SettingsLayoutTopBar.vue?vue&type=script&lang=js"
export * from "./SettingsLayoutTopBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports